module.exports = __webpack_public_path__ + "img/walls.ca241f87.svg";